import { Ref, ref } from "vue";

export default function useStopwatch(alarmInterval?: number) {
    const t: Ref<number> = ref(0);
    const timer: Ref<number> = ref(0);
    const alarm: Ref<boolean> = ref(false);

    const round = (time: number) => {
        return Math.round(time);
    };

    const elapsed = () => {
        // Elapsed time in milliseconds
        return round(t.value < 0 ? t.value + performance.now() : t.value);
    };
    const start = () => {
        setTimer();
        t.value = -performance.now();
        return 0;
    };
    const stop = () => {
        clearTimer();
        t.value += performance.now();
        return round(t.value);
    };
    const reset = () => {
        clearTimer();
        t.value = 0;
        return t.value;
    };
    const setTimer = () => {
        if (!alarmInterval) return;
        timer.value = setInterval(
            () => {
                if (elapsed() > alarmInterval) alarm.value = true;
            },
            Math.round(alarmInterval / 10),
        );
    };
    const clearTimer = () => {
        if (!alarmInterval) return;
        clearInterval(timer.value);
        alarm.value = false;
    };
    return {
        alarm,
        elapsed,
        start,
        stop,
        reset,
    };
}
